import {
  Swiper, Navigation, Scrollbar, Lazy,
} from 'swiper';
import HideOffscreenSlides from '../../components/modules/swiper-hide-offscreen';

/**
 * sliders keeper
 * @type {Array}
 */
const swipers = [];

/**
 * Swiper selector
 * @type {string}
 */
const slider = '.js-image-and-text-swiper';

/**
 * Swiper navigation: scrollbar element selector
 * @type {string}
 */
const scrollbarNavEl = '.swiper-scrollbar';

/**
 * slide preloader class
 * @type {string}
 */
const slidePreloaderClass = 'c-slide-preloader';

function isDesktop() {
  const breakpoint = global.breakpoints ? global.breakpoints.desktop : 992;

  return (window.innerWidth > breakpoint);
}

/**
 * Init slider
 * @return void
 */
function initSlider(el) {
  const options = {
    modules: [Navigation, Scrollbar, Lazy, HideOffscreenSlides],
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 40,
    freeMode: true,
    loop: false,
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      enabled: true,
    },
    lazy: {
      enabled: true,
      loadPrevNext: true,
      preloaderClass: slidePreloaderClass,
    },
    keyboard: true,
    navigation: {
      nextEl: el.nextElementSibling,
      prevEl: el.previousElementSibling,
    },
    autoHeight: false,
    breakpoints: {
      768: {
        freeMode: false,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
      },
    },
    scrollbar: {
      draggable: true,
      el: el.querySelector(scrollbarNavEl),
    },
    on: {
      resize() {
        if (!isDesktop()) {
          this.scrollbar.updateSize();
        }
      },
    },
  };

  const swiper = new Swiper(el, options);

  swiper.init();
  swipers.push(swiper);
}

window.addEventListener('load', () => {
  const items = document.querySelectorAll(slider);

  if (items.length) {
    items.forEach((el) => {
      initSlider(el);
    });
  }
});
